import { STAV } from "b2b/constants/zadosti";

export const isActionsByStavName = dataRow => {
  const name = dataRow?.stav?.name;
  return name === STAV.PRIJATY || name === STAV.NEPOTVRZENY;
};
